import React from 'react';
import OverlayLayout from '../../pages/landingPage/overlayLayout';
import CroppedLayout from '../../pages/landingPage/croppedLayout';

export const Cropped = () => {
  return <CroppedLayout></CroppedLayout>;
};

export const Overlay = () => {
  return <OverlayLayout></OverlayLayout>;
};
